<template>
  <div class="new_center bc_F2F2F2">
    <div class="div_1 d_flex justify_content_sb align_item_c">
      <div class="div_2 d_flex align_item_c">
        <span class="span_1 fz20 c_1A1A1A font_w_bold">新闻资讯</span>
      </div>
      <router-link v-if="cmsNodeChlid" :to="`${cmsNodeChlid.nodeModel.route}/${cmsNodeChlid.id}`" class="div_3 fz12 c_1A1A1A">更多 >></router-link>
    </div>

    <div class="div_2 d_flex justify_content_sb">
      <NewBanner :cms-node-chlid="cmsNodeChlid" />
      <RelatedMessage @chlidNodeChange="chlidNodeChange" />
    </div>
  </div>
</template>

<script>
import NewBanner from '@/views/public_0983cc/home/public/NewBanner.vue'
import RelatedMessage from './RelatedMessage.vue'

export default {
  components: {
    NewBanner,
    RelatedMessage
  },
  data() {
    return {
      cmsNodeChlid: null
    }
  },
  computed: {
  },
  created() {

  },
  methods: {
    chlidNodeChange(cmsNodeChlid) {
      this.cmsNodeChlid = cmsNodeChlid
    }
  }
}
</script>

<style lang="scss" scoped>
.new_center{
  width: 895px;
  height: 328px;
  border: 1px solid #e6e6e6;

  .div_1{
    height: 43px;
    background: url('~@/assets/images/newcenter_2.png') 0 0 no-repeat;

  }
  .div_2{
    margin: 10px 0 0 0;
  }
  .div_3{
    margin: 0 21px 0 0;
  }
  .img_1{
    margin: 0 5px 0 10px;
  }
  .span_1{
    margin: 0 0 0 20px;
  }
}
</style>
